import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown,
  Button,
  Label,
  Checkbox
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardTelepharPostponeUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div>
        <div
          id="CardTelepharPostponeUX-div-1"
          style={{boxShadow: "none", padding: "10px"}}>
          
          <div
            className="ui form small"
            id="CardTelepharPostponeUX-div-2"
            style={{background:"#E9E9E9",margin:"10px 0",padding:"10px 0"}}>
            {}
            <FormGroup
              id="CardTelepharPostponeUX-FormGroup-39"
              inline={true}>
              <FormField
                id="CardTelepharPostponeUX-FormField-83"
                inline={true}
                width={2}>
                <Label
                  id="CardTelepharPostponeUX-Label-100"
                  size="large"
                  style={{minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Name and Surname" : "ชื่อ-สกุล"}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-40"
                inline={true}
                width={3}>
                <Label
                  id="CardTelepharPostponeUX-Label-99"
                  size="large"
                  style={{minWidth:"max-content"}}>
                  {props.patientName}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-85"
                inline={true}>
                <Label
                  id="CardTelepharPostponeUX-Label-101"
                  size="large">
                  {props.languageUX === "en" ? "HN" : "เอชเอ็น"}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-103"
                inline={true}
                width={2}>
                <Label
                  id="CardTelepharPostponeUX-Label-104"
                  size="large"
                  style={{minWidth:"max-content"}}>
                  {props.patientHn}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-86"
                inline={true}>
                <Label
                  id="CardTelepharPostponeUX-Label-102"
                  size="large"
                  style={{minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Type of patient" : "ประเภทผู้ป่วย"}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-43"
                inline={true}>
                <Dropdown
                  id="CardTelepharPostponeUX-Dropdown-57"
                  onChange={props.handleChangeValue("patientType")}
                  options={props.patientOption}
                  selection={true}
                  style={{width: "100%",display: props.isPostpone? "none":"flex"}}
                  value={props.patientType}>
                </Dropdown>
                <Label
                  id="CardTelepharPostponeUX-Label-137"
                  size="large"
                  style={{display: props.isPostpone? "flex":"none"}}>
                  {props.patientType}
                </Label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardTelepharPostponeUX-FormGroup-134"
              inline={true}>
              <FormField
                id="CardTelepharPostponeUX-FormField-125"
                inline={true}
                width={3}>
                <Label
                  id="CardTelepharPostponeUX-Label-129"
                  size="large"
                  style={{...(!props.isPostpone && {display: "none"}),minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Patient request date" : "วันที่ผู้ป่วยร้องขอ"}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-127"
                inline={true}
                width={3}>
                <Label
                  id="CardTelepharPostponeUX-Label-130"
                  size="large"
                  style={{...(!props.isPostpone && {display: "none"}),minWidth:"max-content"}}>
                  {props.patientOldAppointmentDate}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-138"
                inline={true}>
                <Label
                  id="CardTelepharPostponeUX-Label-131"
                  size="large"
                  style={{...(!props.isPostpone && {display: "none"}),minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Patient request time" : "คนไข้ขอเวลา"}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-139"
                inline={true}
                width={2}>
                <Label
                  id="CardTelepharPostponeUX-Label-135"
                  size="large"
                  style={{...(!props.isPostpone && {display: "none"}),minWidth:"max-content"}}>
                  {props.patientOldAppointmentTime}
                </Label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardTelepharPostponeUX-FormGroup-4"
              inline={true}>
              <FormField
                id="CardTelepharPostponeUX-FormField-75"
                inline={true}
                width={2}>
                <Label
                  id="CardTelepharPostponeUX-Label-106"
                  size="large"
                  style={{minWidth:"max-content"}}>
                  {props.languageUX === "en" ? "Appointment date" : "วันที่นัดหมาย"}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-93"
                inline={true}
                width={3}>
                <div
                  id="CardTelepharPostponeUX-div-142"
                  style={{flex:"1"}}>
                  {}
                  <Dropdown
                    disabled={props.disableDate}
                    id="CardTelepharPostponeUX-Dropdown-145"
                    loading={props.divisionLoading}
                    onChange={props.handleChangeValue("patientAppointmentDate")}
                    options={props.dateOption}
                    selection={true}
                    value={props.patientAppointmentDate}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-108"
                inline={true}>
                <Label
                  id="CardTelepharPostponeUX-Label-111"
                  size="large"
                  style={{minWidth:"max-content",marginLeft:"20px"}}>
                  {props.languageUX === "en" ? "Appointment time" : "เวลาที่นัดหมาย"}
                </Label>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-16"
                inline={true}>
                <div
                  id="CardTelepharPostponeUX-div-143"
                  style={{flex:"1"}}>
                  
                  <Dropdown
                    disabled={props.disableTime}
                    id="CardTelepharPostponeUX-Dropdown-113"
                    loading={props.divisionLoading}
                    onChange={props.handleChangeValue("divisionServiceBlockSelected")}
                    options={props.timeOption}
                    selection={true}
                    value={props.divisionServiceBlockSelected}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardTelepharPostponeUX-FormField-109"
                inline={true}
                width={3}>
                <Checkbox
                  checked={props.checkedUnAppointment}
                  id="CardTelepharPostponeUX-Checkbox-112"
                  label={props.languageUX === "en" ? "No appointment specified" : "ไม่ระบุนัดหมาย"}
                  onChange={props.handleChangeChecked("checkedUnAppointment")}
                  style={{marginLeft:"10px"}}>
                </Checkbox>
              </FormField>
              <div
                className="field"
                id="CardTelepharPostponeUX-div-144"
                style={{flex:1}}>
                
              </div>
              <FormField
                id="CardTelepharPostponeUX-FormField-27"
                inline={true}>
                <div
                  id="CardTelepharPostponeUX-div-95"
                  style={{display: props.isPostpone? "none":"flex",minWidth:"max-content",justifyContent: "end",width:"100%"}}>
                  
                  <Button
                    color="blue"
                    disabled={props.handleCheckDisable("addPatient")}
                    id="CardTelepharPostponeUX-Button-97"
                    loading={props.buttonLogin}
                    onClick={props.handleAddPatient}>
                    {props.languageUX === "en" ? "Add patients" : "เพิ่มผู้ป่วย"}
                  </Button>
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardTelepharPostponeUX-div-31"
            style={{display:props.isPostpone && "none" }}>
            
            <Table
              data={props.tableItems}
              getTbodyProps={props.getTbodyProps}
              getTdProps={props.getTdProps}
              getTrProps={props.getTrProps}
              headers="ชื่อ - นามสกุล,HN,ประเภทผู้ป่วย,วันที่นัดหมาย,เวลาที่นัดหมาย,"
              id="tb-bilQueueReq"
              keys="patient_name,hn,patientType,appointmentDate,appointmentTime,delete"
              minRows="8"
              pageSize="5"
              resizable={false}
              showPagination={false}
              style={{height: "55vh"}}>
            </Table>
          </div>
        </div>
      </div>
    )
}


export default CardTelepharPostponeUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{boxShadow: \"none\", padding: \"10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{background:\"#E9E9E9\",margin:\"10px 0\",padding:\"10px 0\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{display:props.isPostpone && \"none\" }"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 32,
      "name": "Table",
      "parent": 31,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableItems"
        },
        "defaultPageSize": {
          "type": "value",
          "value": ""
        },
        "getTbodyProps": {
          "type": "code",
          "value": "props.getTbodyProps"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.getTdProps"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ชื่อ - นามสกุล,HN,ประเภทผู้ป่วย,วันที่นัดหมาย,เวลาที่นัดหมาย,"
        },
        "id": {
          "type": "value",
          "value": "tb-bilQueueReq"
        },
        "keys": {
          "type": "value",
          "value": "patient_name,hn,patientType,appointmentDate,appointmentTime,delete"
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "pageSize": {
          "type": "value",
          "value": "5"
        },
        "resizable": {
          "type": "code",
          "value": "false"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"55vh\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormGroup-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-40"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Dropdown",
      "parent": 43,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Dropdown-57"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"patientType\")"
        },
        "options": {
          "type": "code",
          "value": "props.patientOption"
        },
        "search": {
          "type": "code",
          "value": ""
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",display: props.isPostpone? \"none\":\"flex\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patientType"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-75"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isPostpone? \"none\":\"flex\",minWidth:\"max-content\",justifyContent: \"end\",width:\"100%\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "Button",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มผู้ป่วย",
          "valueEN": "Add patients"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.handleCheckDisable(\"addPatient\")"
        },
        "icon": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Button-97"
        },
        "loading": {
          "type": "code",
          "value": "props.buttonLogin"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.handleAddPatient"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Label",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientName"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-99"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "Label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ-สกุล",
          "valueEN": "Name and Surname"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-100"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Label",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "เอชเอ็น",
          "valueEN": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-101"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Label",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทผู้ป่วย",
          "valueEN": "Type of patient"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-102"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-103"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "Label",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientHn"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-104"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormGroup",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormGroup-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดหมาย",
          "valueEN": "Appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-106"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Label",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาที่นัดหมาย",
          "valueEN": "Appointment time"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-111"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\",marginLeft:\"20px\"}"
        },
        "tag": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Checkbox",
      "parent": 109,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checkedUnAppointment"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Checkbox-112"
        },
        "label": {
          "type": "value",
          "value": "ไม่ระบุนัดหมาย",
          "valueEN": "No appointment specified"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedUnAppointment\")"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"10px\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Dropdown",
      "parent": 143,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.disableTime"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Dropdown-113"
        },
        "loading": {
          "type": "code",
          "value": "props.divisionLoading"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"divisionServiceBlockSelected\")"
        },
        "options": {
          "type": "code",
          "value": "props.timeOption"
        },
        "search": {
          "type": "code",
          "value": ""
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.divisionServiceBlockSelected"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-117"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "Label",
      "parent": 115,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดหมายเดิม",
          "valueEN": "Original appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-119"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "Label",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาที่นัดหมายเดิม",
          "valueEN": "Original appointment time"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-120"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Label",
      "parent": 116,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-121"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "Label",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-122"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "FormField",
      "parent": 134,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-125"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "FormField",
      "parent": 134,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-127"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Label",
      "parent": 125,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ผู้ป่วยร้องขอ",
          "valueEN": "Patient request date"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-129"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{...(!props.isPostpone && {display: \"none\"}),minWidth:\"max-content\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "Label",
      "parent": 127,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientOldAppointmentDate"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-130"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{...(!props.isPostpone && {display: \"none\"}),minWidth:\"max-content\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "Label",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": "คนไข้ขอเวลา",
          "valueEN": "Patient request time"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-131"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{...(!props.isPostpone && {display: \"none\"}),minWidth:\"max-content\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "Label",
      "parent": 132,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-132"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormGroup-134"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "Label",
      "parent": 139,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientOldAppointmentTime"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-135"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{...(!props.isPostpone && {display: \"none\"}),minWidth:\"max-content\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "Label",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientType"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Label-137"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isPostpone? \"flex\":\"none\"}"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormField",
      "parent": 134,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-138"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormField",
      "parent": 134,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-FormField-139"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-div-142"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-div-143"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "field"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-div-144"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Dropdown",
      "parent": 142,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disableDate"
        },
        "id": {
          "type": "value",
          "value": "CardTelepharPostponeUX-Dropdown-145"
        },
        "loading": {
          "type": "code",
          "value": "props.divisionLoading"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"patientAppointmentDate\")"
        },
        "options": {
          "type": "code",
          "value": "props.dateOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.patientAppointmentDate"
        }
      },
      "seq": 145,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "CardTelepharPostponeUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
